<script lang="ts" setup>
import AppModal from "@/components/AppModal.vue";
import UpdateSearchForm from "@/features/searches/UpdateSearchForm.vue";
import type { Search } from "~/common/types/types";

const emit = defineEmits(["close", "submitted"]);

const search = defineModel({
  required: true,
  type: Object as PropType<Search>   
})

function submitted(search: Search) {
  emit("submitted", search);
  closed();
}

function closed() {
    emit("close");
}

</script>
<template>
  <AppModal @close="closed">
    <template #title> Update Search </template>
    <template #body>
      <UpdateSearchForm @submitted='submitted' v-model="search" />
    </template>
  </AppModal>
</template>